import Form from './CancelView';

export default Form;
